import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { getPwmNoteTypesList, INotesListReturnType } from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { IWesterosPwmNoteTypeModalData } from "./types";
import { WesterosPwmNoteTypeModalMode } from "./enums";

const initialState = {
  notesTypeData: null as Nullable<INotesListReturnType["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: WesterosPwmNoteTypeModalMode.VIEW,
  } as IWesterosPwmNoteTypeModalData,
};

export const fetchWesterosPwmNotesTypes = createAsyncThunk(
  "westeros-pwm-note-type/fetchWesterosPwmNotesTypes",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }

    const response = await getPwmNoteTypesList(filters);
    return response;
  }
);

const westerosPwmNoteTypeSlice = createSlice({
  name: "westeros-pwm-note-type",
  initialState,
  reducers: {
    setWesterosPwmNoteTypeModalData: (
      state,
      action: PayloadAction<IWesterosPwmNoteTypeModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeWesterosPwmNoteTypeModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWesterosPwmNotesTypes.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        notesTypeData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchWesterosPwmNotesTypes.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setWesterosPwmNoteTypeModalData,
  closeWesterosPwmNoteTypeModal,
} = westerosPwmNoteTypeSlice.actions;

export default westerosPwmNoteTypeSlice.reducer;
